<template>
  <div class="wrap">
    <div :class="bgColor == '1' ? 'insiderBoxOther' : 'insiderBoxOther'">
      <div class="nameBox">{{ iName }}</div>
      <!-- <van-icon name="cross" @click="del" /> -->
      <img src="@/assets/images/delP.png" alt="" @click="del" v-if="isShow"/>
    </div>
    <div class="repeat-bg" v-if="repeat"></div>
  </div>
  
</template>

<script>
import Vue from 'vue'
import { Icon } from 'vant'
Vue.use(Icon)

export default {
  name: 'InsiderBox',
  props: ['insiderName', 'idx', 'bColor', 'id', 'repeat','showClick'],
  data() {
    return {
      iName: this.insiderName,
      index: this.idx,
      bgColor: this.bColor,
      isShow: this.showClick,
    }
  },
  methods: {
    del() {
      this.idx ? this.$emit('click', this.id, this.idx) : this.$emit('click', this.id)
    },
  },
  watch: {
    showClick: {
      deep: true,
      handler: function () {
        this.isShow = this.showClick
      },
    },
  },
}
</script>

<style lang="less" scoped>
.insiderBox {
  // width: 104px;
  padding: 0 12px;
  height: 40px;
  border-radius: 2px;
  background: #009bff;
  margin-bottom: 12px;
  // border: 1px solid #d9d9d9;
  font-size: 14px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-right: 8px;
}
.insiderBoxOther {
  // width: 104px;
  padding: 0 12px;
  height: 40px;
  border-radius: 2px;
  background: #F4F4F4;
  margin-bottom: 12px;
  // border: 1px solid #d9d9d9;
  font-size: 14px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  margin-right: 8px;

  img {
    width: 8px;
    height: 8px;
  }
}
.nameBox {
  // width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  margin-right: 9px;
  color: #666666;
}
.wrap{
  position: relative;
}
.repeat-bg{
  position: absolute;
  background: url('../../assets/images/repeat_icon.png');
  background-size: 100%;
  background-repeat: no-repeat;
  width: 18px;
  height: 18px;
  top: 0;
  right: 8px;
}
</style>
